/* eslint-disable global-require */

import angular from 'angular';

import RemoveAvailabilityController from './remove-availability.controller';

export default angular.module('autoboard.formRemoveAvailability', [])
  .directive('formRemoveAvailability', () => {
    'ngInject';

    return {
      controller: RemoveAvailabilityController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '<',
      },
      templateUrl: require('./remove-availability.template.html'),
    };
  })
  .name;
